import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/css/fonts/bootstrap-icons.woff";
import "./styles/css/fonts/bootstrap-icons.woff2";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./styles/css/theme.min.css";
import "./styles/css/vendor.min.css";
import "./styles/css/custom.css";
import "./index.css";
import "./App.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
